import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import translationDE from './translation.json'

declare module 'i18next' {
	interface CustomTypeOptions {
		returnNull: false;
	}
}

i18n.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: false,
		fallbackLng: 'de',
		supportedLngs: ['de'],
		resources: {
			de: {
				translation: translationDE,
			}
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
		react: {
			useSuspense: false
		},
		returnNull: false,
		initImmediate: false
	});
export default i18n;
